export default {
  "site.name": "USFansSheet",
  "site.tagline": "Explora, compara y organiza la USFans Spreadsheet",
  "seo.homeTitle": "USFans Spreadsheet – Explora, compara y organiza recursos",
  "seo.homeDesc": "USFansSheet es un centro limpio y útil sobre la USFans Spreadsheet. Navega por categorías, lee guías y comparativas originales y compra en la web principal.",
  "seo.guideTitle": "USFans Spreadsheet – La guía completa",
  "seo.guideDesc": "Descubre qué es una USFans Spreadsheet, cómo usarla y en qué fijarte en esta guía original y detallada con comparativas y preguntas frecuentes.",

  "nav.home": "Inicio",
  "nav.guide": "Guía de compras",
  "nav.categories": "Categorías",
  "nav.faq": "Preguntas",
  "nav.buy": "Comprar ahora",
  "nav.visitMain": "Visitar la web principal",

  "hero.eyebrow": "Centro de recursos de la USFans Spreadsheet",
  "hero.title": "Explora, compara y organiza la USFans Spreadsheet",
  "hero.subtitle": "USFansSheet es un centro limpio y útil construido en torno a la USFans Spreadsheet. Navega por categorías organizadas, lee guías prácticas y compara recursos; luego ve a la web principal para comprarlo todo en un solo lugar.",
  "hero.trust": "Recurso independiente · Actualizado con frecuencia · Enfocado en privacidad y seguridad",
  "hero.cta.main": "USFans Spreadsheet",
  "hero.cta.buy": "Comprar ahora",
  "hero.cta.guide": "Leer la guía",

  "what.title": "¿Qué es una USFans Spreadsheet?",
  "what.text1": "Una USFans Spreadsheet es una forma estructurada de organizar y consultar información de creadores y productos en una única vista con búsqueda. En lugar de saltar entre páginas dispersas, un recurso en forma de hoja reúne todo para que sea más fácil escanear, comparar y entender.",
  "what.text2": "USFansSheet está construido en torno a este tema. Publicamos guías, comparativas y preguntas frecuentes originales que te ayudan a entender los recursos disponibles, y te dirigimos a la web principal donde puedes consultar el catálogo completo.",
  "what.cta": "Explora la guía de la hoja",

  "categories.title": "Navega por categoría",
  "categories.subtitle": "Salta directo a la colección que buscas en la web principal.",
  "drop.label": "Elige una categoría",
  "drop.hint": "Selecciona una categoría para continuar",

  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas / Suéteres",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Shorts",
  "cat.headwear": "Gorros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior / Calzoncillos",
  "cat.jersey": "Camiseta",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otras cosas",

  "features.title": "Por qué USFansSheet",
  "features.1.title": "Organizado",
  "features.1.text": "Todo está agrupado en categorías claras, para que encuentres lo que necesitas sin rebuscar entre páginas dispersas.",
  "features.2.title": "Fácil de comparar",
  "features.2.text": "Usa guías estructuradas y tablas comparativas sencillas para valorar tus opciones antes de hacer clic.",
  "features.3.title": "Seguro y útil",
  "features.3.text": "Mantenemos las cosas claras, honestas y centradas en ayudarte a tomar mejores decisiones, sin ruido ni trucos.",

  "compare.title": "USFans Spreadsheet frente a la búsqueda tradicional",
  "compare.colFeature": "Característica",
  "compare.colA": "Hoja de cálculo",
  "compare.colB": "Búsqueda tradicional",
  "compare.row1.f": "Información estructurada",
  "compare.row1.a": "Sí",
  "compare.row1.b": "Limitada",
  "compare.row2.f": "Comparación sencilla",
  "compare.row2.a": "Sí",
  "compare.row2.b": "Limitada",
  "compare.row3.f": "Organización",
  "compare.row3.a": "Alta",
  "compare.row3.b": "Baja",
  "compare.row4.f": "Filtrado",
  "compare.row4.a": "Posible",
  "compare.row4.b": "Limitado",
  "compare.row5.f": "Apto para principiantes",
  "compare.row5.a": "Sí",
  "compare.row5.b": "Medio",
  "compare.row6.f": "Recursos específicos del tema",
  "compare.row6.a": "Sí",
  "compare.row6.b": "Mixtos",

  "articlePromo.title": "Lee la guía completa de la USFans Spreadsheet",
  "articlePromo.text": "¿Nuevo en el tema? Nuestra guía detallada explica qué es una USFans Spreadsheet, cómo usarla y en qué fijarte, todo en un solo artículo original.",
  "articlePromo.cta": "Abrir la guía",

  "faq.title": "Preguntas frecuentes",
  "faq.q1": "¿Qué es una USFans Spreadsheet?",
  "faq.a1": "Es una forma estructurada y con búsqueda de organizar información de creadores y productos en una sola vista, lo que facilita escanear, comparar y entender.",
  "faq.q2": "¿Es USFansSheet la web oficial de USFans?",
  "faq.a2": "No. USFansSheet es un recurso informativo independiente. Para ver el catálogo completo, visita la web principal.",
  "faq.q3": "¿Dónde puedo consultar los productos?",
  "faq.a3": "Usa el menú de categorías de arriba o visita la web principal directamente. Cada categoría enlaza con su sección correspondiente.",
  "faq.q4": "¿Vendéis productos en este sitio?",
  "faq.a4": "No. Este sitio ofrece guías y recursos. Todos los productos están disponibles en la web principal.",
  "faq.q5": "¿Está segura mi información?",
  "faq.a5": "No recopilamos datos personales ni datos de pago. Verifica siempre la información importante y evita enlaces sospechosos.",
  "faq.q6": "¿Con qué frecuencia se actualiza el contenido?",
  "faq.a6": "Revisamos y actualizamos nuestras guías con regularidad, pero los precios, el stock y los envíos pueden cambiar; consulta siempre los detalles actuales en la web principal.",

  "article.h1": "USFans Spreadsheet: La guía completa",
  "article.short": "Una USFans Spreadsheet es un recurso estructurado y con búsqueda que organiza la información de creadores y productos en un solo lugar, facilitando navegar, comparar y entender. Esta guía explica cómo funciona y en qué fijarte.",
  "article.intro": "Si te has topado con el término “USFans Spreadsheet” y quieres entender qué significa realmente y cómo usarlo, estás en el lugar correcto. Esta guía explica la idea en lenguaje sencillo, muestra en qué fijarte y te ayuda a aprovechar al máximo estos recursos. También te mostramos dónde encontrar el catálogo completo en la web principal.",
  "article.toc.title": "Índice",
  "article.toc.1": "¿Qué es una USFans Spreadsheet?",
  "article.toc.2": "Por qué la gente usa una hoja de cálculo",
  "article.toc.3": "Cómo usar una USFans Spreadsheet",
  "article.toc.4": "Hoja de cálculo frente a búsqueda tradicional",
  "article.toc.5": "Qué buscar en un buen recurso",
  "article.toc.6": "Preguntas frecuentes",
  "article.s1.title": "¿Qué es una USFans Spreadsheet?",
  "article.s1.p": "Una USFans Spreadsheet es una forma estructurada de organizar la información de creadores y productos en una única vista con búsqueda. Piensa en ella como una tabla limpia que agrupa elementos relacionados — nombres, categorías, enlaces y detalles — para que puedas escanearlo todo de un vistazo en lugar de hacer clic en muchas páginas separadas. El objetivo es simple: facilitar encontrar, comparar y entender la información.",
  "article.s2.title": "Por qué la gente usa una hoja de cálculo",
  "article.s2.p": "Las hojas de cálculo son populares por una razón simple: reducen el esfuerzo de buscar. Cuando la información está repartida en muchas páginas, encontrar y comparar opciones lleva tiempo. Una hoja bien organizada reúne los elementos relacionados en un solo lugar, para que veas patrones, detectes diferencias y decidas más rápido. Para un tema como USFans, con muchas categorías y recursos, esa estructura es especialmente útil.",
  "article.s3.title": "Cómo usar una USFans Spreadsheet",
  "article.s3.intro": "Aquí tienes una forma sencilla de empezar, paso a paso:",
  "article.s3.1": "Empieza por las categorías: la mayoría de las hojas agrupan los elementos por categoría, como Zapatos, Sudaderas / Suéteres, Camisetas, Chaquetas y más. Empieza por el grupo que coincida con lo que buscas.",
  "article.s3.2": "Escanea y compara: mira filas y columnas para comparar nombres, detalles y enlaces lado a lado.",
  "article.s3.3": "Sigue la fuente: una buena hoja enlaza con la fuente original. Usa esos enlaces para verificar detalles y ver el panorama completo.",
  "article.s3.4": "Verifica antes de actuar: los precios, el stock y los envíos pueden cambiar. Consulta siempre la información más actual en la web principal.",
  "article.s4.title": "Hoja de cálculo frente a búsqueda tradicional",
  "article.s5.title": "Qué buscar en un buen recurso",
  "article.s5.p": "No todas las hojas son iguales. Un buen recurso está claramente organizado, es fácil de leer y enlaza con una fuente fiable. Debería actualizarse con regularidad y nunca presionarte. Sobre todo, debería respetar tu privacidad y nunca pedir contraseñas, datos de pago ni otra información sensible. Si un recurso pide eso, trátalo como una señal de alerta y sal de ahí.",
  "article.related": "¿Buscas más? Vuelve a la página de inicio para navegar por todas las categorías y recursos, o lee guías relacionadas en nuestra web principal.",
  "article.back": "Volver a la página de inicio",
  "article.cta": "Consulta el catálogo completo en la web principal",
  "article.meta.author": "Equipo editorial de USFansSheet",
  "article.meta.date": "Actualizado con frecuencia",

  "footer.desc": "Un recurso independiente y útil construido en torno a la USFans Spreadsheet. Navega por categorías, lee guías y ve a la web principal para comprarlo todo en un solo lugar.",
  "footer.resources": "Recursos",
  "footer.resources.guide": "Guía de la hoja",
  "footer.resources.categories": "Categorías",
  "footer.resources.faq": "Preguntas frecuentes",
  "footer.main": "Web principal",
  "footer.main.desc": "Visita la web principal para consultar el catálogo completo.",
  "footer.disclaimer": "USFansSheet es un recurso informativo independiente y no está afiliado a la web principal. Todos los productos y compras se gestionan en la web principal.",
  "footer.copyright": "© 2026 USFansSheet. Todos los derechos reservados.",

  "resources.title": "Explora los recursos de USFans",
  "resources.subtitle": "Guías y referencias útiles para navegar, comparar y comprar con confianza.",
  "res.learnMore": "Saber más",
  "res.spreadsheet.title": "USFans Spreadsheet",
  "res.spreadsheet.text": "Guías estructuradas para explorar y organizar recursos de creadores.",
  "res.directory.title": "Directorio de creadores",
  "res.directory.text": "Entiende cómo funcionan los directorios y listas de creadores.",
  "res.reviews.title": "Reseñas",
  "res.reviews.text": "Qué revisar antes de comprar, explicado con honestidad.",
  "res.comparisons.title": "Comparativas",
  "res.comparisons.text": "Compara recursos lado a lado para decidir más rápido.",
  "res.safety.title": "Centro de seguridad",
  "res.safety.text": "Consejos de privacidad, seguridad de cuenta y uso responsable.",
  "res.guides.title": "Guías",
  "res.guides.text": "Tutoriales prácticos para principiantes y usuarios avanzados.",

  "articles.title": "Guías pilar de USFans",
  "articles.subtitle": "Diez guías originales sobre los temas que más busca la gente.",
  "articles.read": "Leer guía",
  "articles.related": "Guías relacionadas",

  "article.notFound": "Artículo no encontrado",
};